/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { useReportsFilter } from "./hooks";
import { resetReportFilters } from "../../../store/filters/Reports/reducers";

interface IReportFilertProps {
  children?: React.ReactNode;
}

export const ReportsFilter: React.FC<IReportFilertProps> = ({ children }) => {
  const { dispatch, filters, formControlSx, searchTooltip } = useReportsFilter();

  return (
    <>
      <GeneralFilter
        dispatch={dispatch}
        filters={filters}
        formControlSx={formControlSx}
        resetFilters={resetReportFilters}
        searchTooltip={searchTooltip}>
        {children && children}
      </GeneralFilter>
    </>
  );
};

export default ReportsFilter;
